<template>
  <div class="myorder-wrap">
    <ul v-if="orderData.length > 0">
      <li class="myorder-promise" @click="handleLink(items.id)" v-for="(items, index) in orderData" :key="index">
        <h3>
          <p>{{items.status_words}}</p>
          <van-button type="primary" color="#0294FF" @click="showModal(items.id)" v-if="items.reapply==='1'">重新申请</van-button>
          <van-button type="primary" color="#CCCCCC" disabled v-else-if="items.reapply==='2'">已申请</van-button>
          <span v-else></span>
        </h3>
        <div class="myorder-manager" v-if="items.grab_user.length > 0">
          <van-image
            round
            :src="items.grab_user.head_avatar"
          />
          <div class="manager-info">
            <p>{{items.grab_user.name}}</p>
            <p class="ellipsis">{{items.grab_user.position}}丨{{items.grab_user.company}}</p>
            <p><van-rate color="#FF4B4D" readonly v-model="items.grab_user.score" size="15"/><em>{{items.grab_user.score}}</em>({{items.grab_user.done_number}}单)</p>
          </div>
        </div>
        <div class="myorder-price">贷款金额：<span>{{items.loan_amount}}万</span><em class="colorFEA802" v-if="items.own_car === '1'">有车</em><em class="color20C272" v-if="items.own_house === '1'">有房</em></div>
        <div class="myorder-info">
          <div><span>{{items.username}}</span><span>{{items.city}}丨{{items.created_at}}</span></div>
          <p><span>工作信息：</span>{{Object.values(items.job_info).join('，')}}</p>
          <p><span>资产信息：</span>{{Object.values(items.assets_info).join('，')}}</p>
        </div>
      </li>
       <!-- <li class="myorder-promise">
        <h3>
          <p>申请已提交，等待信贷经理接单...</p>
          <van-button type="primary" color="#0294FF">重新申请</van-button>
        </h3>
        <div class="myorder-manager">
          <van-image
            round
            src="https://img01.yzcdn.cn/vant/cat.jpeg"
          />
          <div class="manager-info">
            <p>车经理</p>
            <p class="ellipsis">客户经理丨成都阿里妈妈科技创新成都集团有限责任公...</p>
            <p><van-rate color="#FF4B4D" readonly v-model="rateData" size="15"/><em>4.8</em>(75单)</p>
          </div>
        </div>
        <div class="myorder-price">贷款金额：<span>80万</span><em class="colorFEA802">有车</em><em class="color20C272">有房</em></div>
        <div class="myorder-info">
          <div><span>张**</span><span>上海市丨6分钟前</span></div>
          <p><span>工作信息：</span>芝麻分720-950，当前单位6个月以上，社保6...</p>
          <p><span>资产信息：</span>信用卡3万以上，寿险两年以上，有车接受抵押...</p>
        </div>
      </li> -->
    </ul>
    <NoData v-else/>
    <OverlayModal :show="showOverlay"  @closeModal="closeModal" :id="id" :channel_lable="channel_lable"/>
  </div>
</template>
<script>
import { Image as VanImage, Rate, Button } from 'vant';
import { mapActions, mapState } from 'vuex';
import OverlayModal from './overlayModal';
import NoData from '../../../components/noData';
export default {
  name: 'Myorder',
  data() {
    return {
      rateData: 5,
      showOverlay: false,
      channel_lable: this.$route.query.channel_lable,
      id: ''
    }
  },
  created() {
    const loanParams = window.localStorage.getItem('loanParams') ? JSON.parse(window.localStorage.getItem('loanParams')) : {} 
    this.fetchCommon({
      request: 'loan/myorder',
      path: 'loan/myorder',
      data: {
        phone: loanParams.phone ? loanParams.phone : '',
        channel_id: this.channel_lable
      },
    })
  },
  methods: {
    ...mapActions(['fetchCommon']),
    showModal(id) {
      this.showOverlay = true
      this.id = id
    },
    closeModal(value) {
      this.showOverlay = value
    },
    handleLink(id) {
      if(this.showOverlay === false) {
        this.$router.push('/order/detail?id='+id+'&channel_lable='+this.channel_lable)
      }
    }
  },
  computed: {
    ...mapState({
      orderData(state) {
        return state.common['loan/myorder'].data
      }
    }),
  },
  components: {
    [VanImage.name]: VanImage,
    [Rate.name]: Rate,
    [Button.name]: Button,
    [OverlayModal.name]: OverlayModal,
    [NoData.name]: NoData,
  }
}
</script>